import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=2a01c43c&"
import script from "./Placeholder.vue?vue&type=script&lang=ts&"
export * from "./Placeholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports